import { Children, useState } from 'react'
import styled from 'styled-components'
import { P, ICONS, Icon } from '@sellpy/design-system-react-web'

const ExpandableSection = styled.div`
  border-top: ${({ theme }) => `1px solid ${theme.color.grey.shade7}`};
  border-bottom: ${({ theme }) => `1px solid ${theme.color.grey.shade7}`};
`

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  padding: 0.5rem 0;
`

export const ExpandedContent = styled.div`
  transition: all 0.3 ease;
  overflow: hidden;
  padding: 0.5rem 0 1rem 0;
  display: ${({ expanded }) => (expanded ? 'block' : 'none')};
`

const DefaultHeader = ({ onClick, color, header, iconName }) => (
  <HeaderContainer onClick={onClick}>
    <P design={'navSmall'} color={color} noMargin>
      {header}
    </P>
    <Icon name={iconName} style={{ color }} />
  </HeaderContainer>
)

/**
 * @param {Object} props
 * @param {string} props.header
 * @param {Object} [props.style]
 * @param {import('react').ReactNode} props.children
 * @param {string} props.color
 */
const ExpandableList = ({
  header,
  style,
  children,
  color = 'blue',
  className,
  startAsExpanded = false,
  Header = DefaultHeader
}) => {
  const [expanded, setExpanded] = useState(startAsExpanded)
  return (
    <ExpandableSection className={className} style={{ ...style }}>
      <Header
        onClick={() => setExpanded(!expanded)}
        iconName={expanded ? ICONS.CHEVRON_UP : ICONS.CHEVRON_DOWN}
        header={header}
        color={color}
      />
      <ExpandedContent expanded={expanded}>
        {Children.map(children, (child) => child)}
      </ExpandedContent>
    </ExpandableSection>
  )
}

export default ExpandableList
